import { useEffect } from 'react';
import { useWebSocketNotifications } from '../../service/webSocketNotificationService';

interface UseNotificationConnectionProps {
  userId: string | null;
  enabled?: boolean;
}

export const useNotificationConnection = ({
  userId,
  enabled = true
}: UseNotificationConnectionProps) => {
  const { connect, disconnect, isConnected } = useWebSocketNotifications();

  useEffect(() => {
    if (!enabled || !userId) {
      disconnect();
      return;
    }

    // Connect to WebSocket notifications
    connect(userId);

    // Cleanup on unmount or when userId changes
    return () => {
      disconnect();
    };
  }, [userId, enabled, connect, disconnect]);

  // Handle page visibility changes to reconnect when user returns
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible' && userId && enabled) {
        // Reconnect when user returns to tab
        connect(userId);
      } else if (document.visibilityState === 'hidden') {
        // Optionally disconnect when user leaves tab to save resources
        // disconnect();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [userId, enabled, connect]);

  return {
    isConnected: isConnected()
  };
};
